import { Camada, CamadaTiff } from './camada.types';
import { UsuarioProjeto } from './usuario.types';

export enum TIPO_PROJETO {
  ICAD = 'ICAD',
  ICAD2 = 'ICAD2',
  ICAD_DEFAULT = 'ICADPADRAO',
  WEBGEO = 'WEBGEO',
  PVGEO = 'PVGEO',
  OMI_RURAL = 'OMI-RURAL',
  OUV = 'OUV',
  ZONEAMENTO = 'ZONEAMENTO',
}

export const PVG_PORTAL_KEY = 'ovi';
export const RURAL_OVI_PORTAL_KEY = 'ovi-rural';
export const GENERIC_PORTAL_KEY = 'simples';

export function isRuralOviRoute(url: string): boolean {
  return url.split(/[?#]/)[0].split('/').includes(RURAL_OVI_PORTAL_KEY);
}
export interface Projeto {
  id: number;
  nome: string;
  alias?: string;
  tipoProjeto: keyof typeof TIPO_PROJETO | TIPO_PROJETO;
  cidade: string;
  configuracao?: string;
  usuario: UsuarioProjeto;
  ativo: boolean;
  projetosCamadas: Camada[];
  importacoesDxf: Camada[];
  importacoesTiff: CamadaTiff[];
  importacoesWms: Camada[];
  qtdCamadas: number;
  qtdGeometrias: number;
  hierarquias?: string;
}
